// extracted by mini-css-extract-plugin
export default {"customer-data":"CustomerData_customer-data__cl8Vx"};